module.exports = __webpack_public_path__ + "img/ground-sea-evening.de233196.png";